import {clearView, viewVideo} from "@/redux/slices/videoSlices/viewSlice";

import {useEffect, useMemo, useRef} from "react";

import requirements_preductal from "@fallbackVideos/Requirements_for_a_visit_to_Preductal_OD.png";
import requirements_tujeo from "@fallbackVideos/Requirements_for_visiting_Tujeo.png";
import research_choice_2 from "@fallbackVideos/Research_CHOICE_2.png";
import doctorObjections from "@fallbackVideos/doctor-objections.jpg";
import painxicam from "@fallbackVideos/painxicam.png";
import rolexin from "@fallbackVideos/rolexin.png";
import sideEffects from "@fallbackVideos/side-effects.png";
import {BackButton} from "@ui/buttons/BackButton";
import {ViewField} from "@ui/forms/ViewField";
import {ViewTitle} from "@ui/forms/ViewTitle";
import {BorderArticle} from "@ui/general/BorderArticle";
import {PreviewCard} from "@ui/general/PreviewCard";
import {Spinner} from "@ui/general/Spinner";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {useLocation, useNavigate, useParams} from "react-router-dom";

import styles from "./styles.module.scss";

export const VideoViewPage = () => {
  const {isMobile} = useSelector((state) => state.common.settings);
  const {status} = useSelector((state) => state.video.view);
  const {t} = useTranslation();
  const {id} = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const servier_test_server = window.location.host.includes("servier");
  const sanofi_test_server = window.location.host.includes("sanofi");
  // const localhost = window.location.host.includes('localhost')

  const videoRef = useRef();

  const data = useMemo(() => {
    if (servier_test_server) {
      return [
        {
          id: 0,
          name: t("video_servier_1.name"),
          product: t("video_servier_1.product"),
          line: t("video_servier_1.line"),
          country: t("video_servier_1.country"),
          image: requirements_preductal,
          mask: "pinkGr",
          description: t("video_servier_1.desc"),
          inactive: false,
        },
        {
          id: 1,
          name: t("video_servier_2.name"),
          product: t("video_servier_2.product"),
          line: t("video_servier_2.line"),
          country: t("video_servier_2.country"),
          mask: "peachGr",
          image: research_choice_2,
          description: t("video_servier_2.desc"),
          inactive: false,
        },
      ];
    }

    if (sanofi_test_server) {
      return [
        {
          id: 0,
          name: t("video_sanofi_1.name"),
          product: t("video_sanofi_1.product"),
          line: t("video_sanofi_1.line"),
          country: t("video_sanofi_1.country"),
          image: requirements_tujeo,
          mask: "peachGr",
          description: t("video_sanofi_1.desc"),
          inactive: false,
        },
      ];
    }

    return [
      {
        id: 0,
        name: t("video_1.name"),
        product: t("video_1.product"),
        line: t("video_1.line"),
        country: t("video_1.country"),
        image: doctorObjections,
        mask: "pinkGr",
        description: t("video_1.desc"),
        created_at: "2024-10-21",
        inactive: false,
      },
      {
        id: 1,
        name: t("video_2.name"),
        product: t("video_2.product"),
        line: t("video_2.line"),
        country: t("video_2.country"),
        mask: "peachGr",
        image: rolexin,
        description: t("video_2.desc"),
        inactive: false,
      },
      {
        id: 2,
        name: t("video_3.name"),
        product: t("video_3.product"),
        line: t("video_3.line"),
        mask: "violetGr",
        country: t("video_3.country"),
        image: painxicam,
        description: t("video_3.desc"),
        created_at: "2024-10-21",
        inactive: false,
      },
      {
        id: 3,
        name: t("video_4.name"),
        product: t("video_4.product"),
        line: t("video_4.line"),
        mask: "violetGr",
        country: t("video_4.country"),
        image: sideEffects,
        description: t("video_4.desc"),
        created_at: "2024-10-21",
        inactive: false,
      },
    ];
  }, [servier_test_server, sanofi_test_server, t]);

  const handleClickEdit = async (id) => {
    navigate(`/admin-panel/videos/edit/${id}`, {state: {id}});
  };

  useEffect(() => {
    dispatch(viewVideo({id}));

    return () => {
      dispatch(clearView());
    };
  }, [dispatch]);

  useEffect(() => {
    if (videoRef.current && isMobile) {
      videoRef.current.scrollIntoView({behavior: "smooth"});
    }
  }, [location]);

  return (
    <div
      ref={videoRef}
      className={styles.videoWrapper}
    >
      <BorderArticle>
        <div className={styles.video}>
          <div className={styles.videoHead}>
            <BackButton />
          </div>

          {status === "loading" ? (
            <Spinner
              width={80}
              height={80}
            />
          ) : (
            <div className={styles.videoContent}>
              <div className={styles.videoContentHead}>
                <ViewTitle
                  value={data[id]?.name}
                  handleClickEdit={() => handleClickEdit(data[id]?.id)}
                />

                <ViewField
                  label={t("input.preview")}
                  direction={"col"}
                  customContent={
                    <PreviewCard
                      name={data[id]?.name}
                      mask={data[id]?.mask}
                      image={data[id]?.image}
                    />
                  }
                />
              </div>

              <ul className={styles.videoContentBody}>
                <ViewField
                  label={t("input.related_products")}
                  value={data[id]?.product}
                />

                <ViewField
                  label={t("input.product_line")}
                  value={data[id]?.line}
                />

                <ViewField
                  label={t("input.country")}
                  value={data[id]?.country}
                />

                <ViewField
                  label={t("input.description")}
                  value={data[id]?.description}
                />
              </ul>
            </div>
          )}
        </div>
      </BorderArticle>
    </div>
  );
};
